import React from 'react';
import l10n from "../../../l10n/localization";
import {Row} from "react-materialize";
import {connect} from "react-redux";
import {fetchFogs} from "../../../actions/fog";
import * as filesActions from "../../../actions/files";
import FileItem from "./FileItem";
import Dropzone from 'react-dropzone';
//import { ACCEPTEDMIMETYPE } from "../../../constants/common";

class FilesUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDirty : false,
            files: []
        };
    }

    componentDidMount() {
        if (!this.props.displayAll) {
            this.props.dispatch(fetchFogs(true));
        } else {
            this.props.dispatch(fetchFogs(true, true));
        }

        this.props.dispatch(filesActions.fetchFile(this.props.fog.id));
    }

    onDrop(files) {
        this.setState({
            files: files,
            isDirty: true
        });
    }

    clearMemory = (files) =>{
        files.map((file)=> {
            window.URL.revokeObjectURL(file.preview);
            return file;
        });
    };

    handleSubmit = () => {

        this.state.files.map((file)=>{
            let formData = new FormData();
            formData.append("fogfile", file);
            this.props.dispatch(filesActions.add(formData,this.props.fog.id));
            return file;
        });
        if(this.state.files) {
            this.setState({
                files: [],
                isDirty: false
            });
        }

        this.clearMemory(this.state.files);
        this.props.dispatch(filesActions.fetchFile(this.props.fog.id));
    };

    getFileIcon = (mimeType,typeFull) =>{
        let icon = '';
        switch(mimeType){
            case 'text':
                icon = 'fa-file-text-o';
                break;
            case 'image':
                icon = 'fa-file-image-o';
                break;
            case 'video':
                icon = 'fa-file-video-o';
                break;
            case 'application':
                icon = 'fa-file';

                if(typeFull === 'application/pdf'){
                    icon = 'fa-file-pdf-o';
                }

                if(typeFull === 'application/msword'){
                    icon = 'fa-file-word-o';
                }

                if(typeFull === 'application/vnd.ms-powerpoint'){
                    icon = 'fa-file-powerpoint-o';
                }

                if((typeFull === 'application/vnd.ms-excel') || (typeFull === 'application/vnd.ms-excel.addin.macroEnabled.12') || (typeFull === 'application/vnd.ms-excel.sheet.binary.macroEnabled.12') || (typeFull === 'application/vnd.ms-excel.sheet.macroEnabled.12') || (typeFull === 'application/vnd.ms-excel.template.macroEnabled.12')){
                    icon = 'fa-file-excel-o';
                }

                if((typeFull === 'application/x-rar-compressed') || (typeFull === 'application/x-tar') || (typeFull === 'application/zip') || (typeFull === 'application/x-7z-compressed')) {
                    icon = 'fa-file-archive-o';
                }

                break;
            default:
                icon = 'fa-file-o';
        }

        return icon;
    };

    getFilesInformations = (f,i) =>{

        let splitType = (f.type) ? f.type.split('/') : ['',''];
        let icon = this.getFileIcon(splitType[0],f.type);
        return(<tr key={`file-item-${i}`} className="file-item"><td><i className={`fa ${icon}`} aria-hidden="true"></i></td><td><span>{f.name}</span></td></tr>);
    };

    getFilesComponent = (f,i) =>{
        let splitType = (f.mimetype) ? f.mimetype.split('/') : ['',''];
        let extension = splitType[1];
        let icon = this.getFileIcon(splitType[0],f.mimetype);

        return(<FileItem key={`file-item-${i}`} fogId={this.props.fog.id} name={f.name} id={f.id} icon={icon} extension={extension} size={f.size}  file={f} />);
    };

    render() {

        let formClassName = (this.state.isDirty) ? 'filesUpload-wrapper dirty':'filesUpload-wrapper';
        //const acceptMime = ACCEPTEDMIMETYPE;

        return (
            <div className={formClassName}>
                <Row>
                    {
                        (this.props.current.length)
                        ?
                            <section>
                                <h4 className="yellow-border">{l10n.fog.filesUploaded}</h4>
                                <div className="content">
                                    <section>
                                        <div className="col-md-12">
                                            <table className="table table-sm table-striped table-hover file-list-table">
                                                <thead>
                                                <tr>
                                                    <th data-key="icons"></th>
                                                    <th data-key="name th-item"><span>Name</span></th>
                                                    <th data-key="icons"></th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                { this.props.current.map(this.getFilesComponent) }
                                                </tbody>
                                            </table>
                                        </div>
                                    </section>
                                </div>
                                <br/>
                            </section>
                        :
                            null
                    }
                    <section>
                        <h4 className="yellow-border">{l10n.fog.filesReady}</h4>
                        <div className="content">
                            <section>
                                <div className="col-md-12">
                                    <table className="table table-sm table-striped table-hover file-list-table">
                                        <thead>
                                        <tr>
                                            <th data-key="icons"></th>
                                            <th data-key="name"><span>Name</span></th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {
                                            this.state.files.map(this.getFilesInformations)
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                            <section>
                                <div className="dropzone">
                                    <Dropzone
                                        style={{
                                            width: '100%',
                                            height: '300px',
                                            border: '1px dashed #ccc',
                                            textAlign: 'center',
                                            margin: '2em 0 1em',
                                            padding: '2em',
                                            fontSize: '2em'
                                        }}
                                        acceptStyle={{
                                            backgroundColor: 'rgba(174,213,129,0.8)'
                                        }}
                                        rejectStyle={{
                                            borderColor: 'rgba(255,0,0,1)'
                                        }}
                                        className="dropzone-container"
                                        activeClassName="dropzone-active"
                                        acceptClassName="dropzone-accept"
                                        rejectClassName="dropzone-reject"
                                        disabledClassName="dropzone-disabled"
                                        onDrop={this.onDrop.bind(this)}
                                        /*accept={acceptMime}*/>
                                        {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
                                            if (isDragReject) {
                                                return "This file is not authorized";
                                            } else {
                                                if(isDragActive){
                                                    return "This file is authorized";
                                                } else {
                                                    return <span className="placeholder">{"Drop files here"}</span>;
                                                }
                                            }
                                        }}
                                    </Dropzone>
                                </div>
                            </section>
                        </div>
                    </section>
                </Row>
                <button className="btn btn-primary validate" onClick={this.handleSubmit} disabled={this.props.loading}>upload</button>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.files.loading,
        saving: state.files.saving,
        deleting: state.files.deleting,
        formData: state.files.formData,
        files: state.files.files,
        current: state.files.current,

        displayAll: state.connect.displayAll,
    });
})(FilesUpload);


// WEBPACK FOOTER //
// ./src/components/fog/FilesUpload/FilesUpload.js